import React from 'react';
import { DisplayFilter as Filter } from './Filter';
import { SummaryTable } from './SummaryTable';
export { useDisplayFilter } from './useDisplayFilter';

export const DisplayFilter = ({ lineups, displayTypes, lineup }) => {
  return (
    <div className="s-lineup-explorer__filter filter">
      <h3 className="s-lineup-explorer__metrics-header">
        Metrics - Single Lineup
      </h3>
      <Filter lineups={lineups} displayTypes={displayTypes} />
      <SummaryTable lineup={lineup} />
    </div>
  );
};
